export default "__VITE_ASSET__J_Bo9jr4__"